import { Component } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { ItemType } from '../../../services/dto/item-type';
import { AbstractCellComponent } from '../../abstract';

export const itemTypeLabel = (itemType: number) => `core.types.${ItemType[itemType]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-item-type-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [BadgeComponent, TranslatePipe],
  template: `
    @if (this.show) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-badge class="d-flex" [type]="this.getType()" [value]="this.getTranslate() | translate"></cam-badge>
      </div>
    }
  `,
})
export class GridItemTypeCellComponent extends AbstractCellComponent<unknown, number> {
  get show() {
    return this.value !== ItemType.Normal && this.value !== ItemType.Unknown && this.value !== null;
  }

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public getType(): ColorType {
    switch (this.value) {
      case ItemType.Reduction:
        return 'success';
      case ItemType.Omission:
        return 'alert';
      case ItemType.Options:
        return 'warning';
      case ItemType.Variant:
        return 'purple';
      default:
        return 'default';
    }
  }

  public getTranslate() {
    return itemTypeLabel(this.value ?? ItemType.Unknown);
  }
}
